module.exports = __webpack_public_path__ + "static/media/bloomberg.dbba4450.svg";